export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gesamte Abbuchung"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kommission"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Info"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gutschrift"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betrag kann nicht berechnet werden"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unzureichende Mittel für die Zahlung"])}
}